import React, { useEffect, useState } from 'react'
import '../../App.css'
import LineProgressBar from './components/LineProgressBar'
import { Icon } from '../../components/Icon'
import { useQuery } from 'react-query'
import { getScrRecord } from './apiCalls'
import { useToggledSwitches } from '../../context/ToggledSwitchesContext'
import Loading from '../../components/UI/Loading'

import {
  calculateNonNullPercentage,
  aggregateTrainingScore,
  capitalizeFirstLetter,
} from '../../utils/utils'

import { statusBgColor } from './utils'

const CenteralRecordsGroupGovernor = () => {
  const { toggledSwitches } = useToggledSwitches()
  function getStoredIds(key: string): string[] {
    // Retrieve the JSON string from local storage
    const storedIdsString = localStorage.getItem(key)

    // Parse the JSON string and return it as an array
    if (storedIdsString) {
      try {
        const storedIds = JSON.parse(storedIdsString)

        // Ensure that the parsed data is an array of strings
        if (
          Array.isArray(storedIds) &&
          storedIds.every((id) => typeof id === 'string')
        ) {
          return storedIds
        } else {
          return []
        }
      } catch (error) {
        return []
      }
    }

    // Return an empty array if there's no data in local storage
    return []
  }

  const schoolIds = getStoredIds('SchoolIds')

  const [sortOrder, setSortOrder] = useState<{
    [key: string]: 'asc' | 'desc'
  }>({})
  const [sortBy, setSortBy] = useState<string>('firstName')
  const [sortOrderValue, setSortOrderValue] = useState<string>('asc')

  const [activeTab, setActiveTab] = useState<string>('tab1')
  const scrRecords = useQuery(
    'scr',
    () =>
      getScrRecord(
        toggledSwitches.length > 0 ? toggledSwitches : schoolIds,
        currentPage,
        sortBy,
        sortOrderValue,
        activeTab
      ),
    {
      enabled: false,
    }
  )

  const handleSort = (key: string) => {
    const newSortOrder = { ...sortOrder }
    if (newSortOrder[key] === 'asc' || newSortOrder[key] === undefined) {
      newSortOrder[key] = 'desc'
      setSortBy(key)
      setSortOrderValue('desc')
    } else {
      newSortOrder[key] = 'asc'
      setSortBy(key)
      setSortOrderValue('asc')
    }
    setSortOrder(newSortOrder)
  }

  useEffect(() => {
    scrRecords.refetch() // Refetch incidents when sortBy or sortOrderValue changes
  }, [sortBy, sortOrderValue])

  const [currentPage, setCurrentPage] = useState<number>(1)

  // const handlePageChange = (pageNumber: number): void => {
  //   setCurrentPage(pageNumber)
  // }

  useEffect(() => {
    scrRecords.refetch()
    setCurrentPage(1)
  }, [currentPage, activeTab])

  useEffect(() => {
    scrRecords.refetch()
  }, [toggledSwitches])

  return (
    <>
      <div
        className={
          'flex flex-col gap-6 w-full bg-white  h-full rounded-3xl p-8 '
        }
      >
        <div className="flex flex-col gap-6 w-full relative h-full">
          <div className={'flex w-full justify-between items-start '}>
            <div className="flex-col w-[50%] gap-[20px]">
              <p className={'text-lg leading-5 font-bold text-text2'}>
                Single Central Records
              </p>
            </div>
          </div>
          <div className="flex w-[100%] space-x-4">
            <button
              className={`rounded-[72px]  w-[50%] px-4 py-2 font-semibold ${activeTab === 'tab1' ? 'bg-bluishGreen text-white' : 'bg-gray2 text-bluishGreen'}`}
              onClick={() => setActiveTab('tab1')}
            >
              All
            </button>
            <button
              className={`rounded-[72px] w-[50%] px-4 py-2 font-semibold ${activeTab === 'tab2' ? 'bg-bluishGreen text-white' : 'bg-gray2 text-bluishGreen'}`}
              onClick={() => setActiveTab('tab2')}
            >
              Archived
            </button>
          </div>
          {/* content container */}
          <div className="flex h-[80%] flex-col gap-[3px]">
            <div className="bg-gray2 rounded-xl flex ">
              <div className="px-4 py-3 w-[18%] flex items-center border-r-2 border-r-white">
                <p className="text-sm font-semibold leading-6 text-text1 flex-1">
                  Name
                </p>
                <div
                  className="cursor-pointer"
                  onClick={() => {
                    handleSort('firstName')
                  }}
                >
                  <Icon
                    name={'IconChevronDown'}
                    width={16}
                    height={16}
                    strokeWidth={1}
                    stroke={'#67A5B9'}
                  />
                </div>
              </div>
              <div className="px-4 py-3 w-[20%] flex items-center border-r-2 border-r-white">
                <p className="text-sm font-semibold leading-6 text-text1 flex-1">
                  Role
                </p>
                <div
                  className="cursor-pointer"
                  onClick={() => {
                    handleSort('role')
                  }}
                >
                  <Icon
                    name={'IconChevronDown'}
                    width={16}
                    height={16}
                    strokeWidth={1}
                    stroke={'#67A5B9'}
                  />
                </div>
              </div>
              <div className="px-4 py-3 w-[15%] flex items-center border-r-2 border-r-white">
                <p className="text-sm font-semibold leading-6 text-text1 flex-1">
                  Profile
                </p>
                <div className="cursor-pointer">
                  <Icon
                    name={'IconChevronDown'}
                    width={16}
                    height={16}
                    strokeWidth={1}
                    stroke={'#67A5B9'}
                  />
                </div>
              </div>
              <div className="px-4 py-3 w-[15%] flex items-center border-r-2 border-r-white">
                <p className="text-sm font-semibold leading-6 text-text1 flex-1">
                  Safeguarding
                </p>
                <div className="cursor-pointer">
                  <Icon
                    name={'IconChevronDown'}
                    width={16}
                    height={16}
                    strokeWidth={1}
                    stroke={'#67A5B9'}
                  />
                </div>
              </div>

              <div className="px-4 py-3 w-[15%] flex items-center border-r-2 border-r-white">
                <p className="text-sm font-semibold leading-6 text-text1 flex-1">
                  Training
                </p>
                <div className="cursor-pointer">
                  <Icon
                    name={'IconChevronDown'}
                    width={16}
                    height={16}
                    strokeWidth={1}
                    stroke={'#67A5B9'}
                  />
                </div>
              </div>
              <div className="px-4 py-3 w-[13%] flex items-center">
                <p className="text-sm font-semibold leading-6 text-text1 flex-1">
                  Status
                </p>
                <div
                  className="cursor-pointer"
                  onClick={() => {
                    handleSort('status')
                  }}
                >
                  <Icon
                    name={'IconChevronDown'}
                    width={16}
                    height={16}
                    strokeWidth={1}
                    stroke={'#67A5B9'}
                  />
                </div>
              </div>
            </div>
            <div
              id={'#container'}
              className="w-full h-[100%] overflow-x-hidden flex justify-center items-baseline relative overflow-scroll"
            >
              {/* table component */}
              <div className="overflow-hidden w-full flex flex-col gap-[3px]">
                {scrRecords.isLoading && (
                  <div className="flex-col  w-[100%] p-[10px]">
                    <Loading size="large" />
                  </div>
                )}
                {!scrRecords.isLoading && (
                  <>
                    {scrRecords.data?.data?.map((item, index) => {
                      return (
                        <>
                          <div key={index} className="bg-gray1 rounded-xl flex">
                            <div className="px-4 py-2 w-[18%] flex items-center border-r-2 border-r-white gap-3 cursor-pointer">
                              {item?.profileImageUrl == null ? (
                                <div className="flex items-center justify-center rounded-full bg-bluishGreen text-white w-10 h-10 border-4 border-[#FFFFFF33]">
                                  <p className="text-xs text-white font-medium">
                                    {item?.firstName?.charAt(0)?.toUpperCase()}{' '}
                                    {item?.lastName?.charAt(0)?.toUpperCase()}
                                  </p>
                                </div>
                              ) : (
                                <div className="flex items-center justify-center rounded-full bg-bluishGreen text-white w-10 h-10 border-4 border-[#FFFFFF33]">
                                  <img
                                    src={item?.profileImageUrl}
                                    width={8}
                                    height={8}
                                    alt=""
                                    className="rounded-full bg-transparent border-none w-8 h-8"
                                  />
                                </div>
                              )}

                              <div>
                                <p className="text-sm font-semibold leading-6 text-text2">
                                  {item?.firstName} {item?.lastName}
                                </p>
                              </div>
                            </div>
                            <div className="px-4 py-2 w-[20%] flex items-center border-r-2 border-r-white">
                              <div className="rounded-[40px] bg-gray3 p-2 px-3">
                                <p className="text-xs font-medium leading-5 text-bluishGreen">
                                  {item?.role}
                                </p>
                              </div>
                            </div>
                            <div className="px-4 py-2 w-[15%] flex items-center border-r-2 border-r-white">
                              <LineProgressBar
                                percentage={
                                  calculateNonNullPercentage([
                                    item.firstName,
                                    item.lastName,

                                    item.gender,
                                    item.dateOfBirth,
                                    item.ethnicity,
                                    item.disability,
                                    item.businessContactNumber,
                                    item.businessEmail,
                                    item.personalContactNumber,
                                    item.personalEmail,
                                    // item.extensionNumber,
                                    item.addressLineOne,
                                    // item.addressLineTwo,
                                    item.town,
                                    item.country,
                                    item.postCode,
                                    item.e_contact_addressLineOne,
                                    // item.e_contact_addressLineTwo,
                                    item.e_contact_contactNumber,
                                    item.e_contact_country,
                                    item.e_contact_firstName,
                                    item.e_contact_lastName,
                                    item.e_contact_postCode,
                                    item.e_contact_relationship,
                                    item.e_contact_town,
                                  ])?.percentage
                                }
                                stroke={
                                  calculateNonNullPercentage([
                                    item.firstName,
                                    item.lastName,
                                    item.email,
                                    item.gender,
                                    item.dateOfBirth,
                                    item.ethnicity,
                                    item.disability,
                                    item.businessContactNumber,
                                    item.businessEmail,
                                    item.personalContactNumber,
                                    item.personalEmail,
                                    // item.extensionNumber,
                                    item.addressLineOne,
                                    // item.addressLineTwo,
                                    item.town,
                                    item.country,
                                    item.postCode,
                                    item.e_contact_addressLineOne,
                                    // item.e_contact_addressLineTwo,
                                    item.e_contact_contactNumber,
                                    item.e_contact_country,
                                    item.e_contact_firstName,
                                    item.e_contact_lastName,
                                    item.e_contact_postCode,
                                    item.e_contact_relationship,
                                    item.e_contact_town,
                                  ])?.color
                                }
                                strokeWidth={1.5}
                              />
                            </div>
                            <div className="px-4 py-2 w-[15%] flex items-center border-r-2 border-r-white">
                              <LineProgressBar
                                percentage={
                                  calculateNonNullPercentage([
                                    item?.DBScertificate,
                                    item?.DBScertificateNumber,
                                    item?.DBSduration,
                                    item?.DBSissueDate,
                                    item?.DBSreviewDate,
                                    item?.DBSriskAssessmentStatus,
                                    item?.DBSverificationDate,
                                    item?.DBSverifiedBy,
                                    item?.Identifications[0]?.certificate,
                                    item?.Identifications[0]?.evidenceType,
                                    item?.Identifications[0]?.verificationDate,
                                    item?.Identifications[0]?.verifiedBy,
                                    item?.Identifications[1]?.certificate,
                                    item?.Identifications[1]?.evidenceType,
                                    item?.Identifications[1]?.verificationDate,
                                    item?.Identifications[1]?.verifiedBy,
                                    item?.ReferenceChecks[0]?.verificationDate,
                                    item?.ReferenceChecks[0]?.verifiedBy,
                                    item?.ReferenceChecks[0]?.certificate,
                                    item?.ReferenceChecks[1]?.verificationDate,
                                    item?.ReferenceChecks[1]?.verifiedBy,
                                    item?.ReferenceChecks[1]?.certificate,
                                    item?.RTW_certificate,
                                    item?.RTW_evidenceType,
                                    item?.RTW_expiryDate,
                                    item?.RTW_verificationDate,
                                    item?.RTW_verifiedBy,
                                  ]).percentage
                                }
                                stroke={
                                  calculateNonNullPercentage([
                                    item?.DBScertificate,
                                    item?.DBScertificateNumber,
                                    item?.DBSduration,
                                    item?.DBSissueDate,
                                    item?.DBSreviewDate,
                                    item?.DBSriskAssessmentStatus,
                                    item?.DBSverificationDate,
                                    item?.DBSverifiedBy,
                                    item?.Identifications[0]?.certificate,
                                    item?.Identifications[0]?.evidenceType,
                                    item?.Identifications[0]?.verificationDate,
                                    item?.Identifications[0]?.verifiedBy,
                                    item?.Identifications[1]?.certificate,
                                    item?.Identifications[1]?.evidenceType,
                                    item?.Identifications[1]?.verificationDate,
                                    item?.Identifications[1]?.verifiedBy,
                                    item?.ReferenceChecks[0]?.verificationDate,
                                    item?.ReferenceChecks[0]?.verifiedBy,
                                    item?.ReferenceChecks[0]?.certificate,
                                    item?.ReferenceChecks[1]?.verificationDate,
                                    item?.ReferenceChecks[1]?.verifiedBy,
                                    item?.ReferenceChecks[1]?.certificate,
                                    item?.RTW_certificate,
                                    item?.RTW_evidenceType,
                                    item?.RTW_expiryDate,
                                    item?.RTW_verificationDate,
                                    item?.RTW_verifiedBy,
                                  ]).color
                                }
                                strokeWidth={1.5}
                              />
                            </div>
                            <div className="px-4 py-2 w-[15%] flex items-center border-r-2 border-r-white">
                              <LineProgressBar
                                percentage={
                                  aggregateTrainingScore(
                                    item?.trainingRecordCategory,
                                    item?.trainingRecords
                                  ).percentage
                                }
                                stroke={
                                  aggregateTrainingScore(
                                    item?.trainingRecordCategory,
                                    item?.trainingRecords
                                  ).color
                                }
                                strokeWidth={1.5}
                              />
                            </div>
                            <div className="px-4 py-2 w-[13%] flex items-center">
                              <div className="flex items-center gap-2">
                                <div
                                  className={`rounded-[40px] bg-${statusBgColor(item?.status)} p-2 px-3 flex-1`}
                                >
                                  <p className="text-xs font-medium leading-5 text-bluishGreen">
                                    {capitalizeFirstLetter(item?.status)}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </>
                      )
                    })}
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default CenteralRecordsGroupGovernor
